module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-down.d247580e.svg";